import {Component, Input, OnInit} from '@angular/core';
import {ChangeRequestVO} from '../../../generate/TldChangeResultVO';

@Component({
    selector: 'change-request-header-block',
    templateUrl: './change-request-header-block.component.html',
    styleUrls: ['./change-request-header-block.component.scss'],
    standalone: false
})
export class ChangeRequestHeaderBlockComponent implements OnInit {
  constructor() { }

  @Input()
  changeRequestVO: ChangeRequestVO;

  @Input()
  changeRequestID: ChangeRequestVO;

  ngOnInit() {
  }

}
